import React from "react";

const reasons = [
  {
    title: "Farmer-Centric Approach",
    desc: "Every product is developed using real farmer feedback and on-field experience to deliver reliable results."
  },
  {
    title: "Eco-Friendly Formulations",
    desc: "Our solutions protect crops while maintaining soil health, water safety, and environmental balance."
  },
  {
    title: "Strict Quality Control",
    desc: "From raw materials to final packaging, every stage follows strict quality and safety standards."
  },
  {
    title: "300+ Quality Products",
    desc: "A wide range of crop protection and nutrition products for multiple crops and climatic conditions."
  },
  {
    title: "Pan-India Distribution",
    desc: "Strong distribution network ensures timely availability and dependable supply across India."
  },
  {
    title: "Trusted Industry Experience",
    desc: "Over 10+ years of experience supporting farmers with consistent performance and honest practices."
  }
];

const WhyChooseUs = () => {
  return (
    <section className="why-choose-section">
      <div className="container">

        {/* HEADING */}
        <div className="text-center mb-5">
          <h6 className="section-subtitle">WHY CHOOSE US</h6>
          <h2 className="section-title">
            Why Farmers <span>Trust Goodweel</span>
          </h2>
          <p className="section-desc">
            We combine technology, quality, and real farming experience to deliver
            sustainable agricultural solutions farmers can rely on.
          </p>
        </div>

        {/* CARDS */}
        <div className="row">
          {reasons.map((item, index) => (
            <div className="col-lg-4 col-md-6 mb-4" key={index}>
              <div className="why-card">
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default WhyChooseUs;
